import firebase from 'firebase'
import 'firebase/auth'
import 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBDju1z7WpRxT2Qph0pJTx3p9iJdmYTjGM",
  authDomain: "whatsapp-f5136.firebaseapp.com",
  projectId: "whatsapp-f5136",
  storageBucket: "whatsapp-f5136.appspot.com",
  messagingSenderId: "960843807741",
  appId: "1:960843807741:web:86df4a2252445af5cbf794"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const app = firebase;
export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage()
export default app